import { useRef } from "react";
import { KeyboardArrowDownRounded, LockRounded } from "@mui/icons-material";

import { Popper, Text } from "@fragments";

import { MEMBER_ROLE_LABEL, MEMBER_ROLES } from "../../../enums";

import "./styles.scss";

const ROLE_TONE = {
  owner: "owner",
  admin: "admin",
  creator: "creator",
  member: "member",
};

const NON_EDITABLE_ROLES = new Set(["owner", "admin"]);

export default function RoleCell({ member, onChangeRole }) {
  const popperRef = useRef(null);

  const role = member?.role;
  if (!role) return <Text.span contrast={6}>—</Text.span>;

  const tone = ROLE_TONE[role] || "member";
  const label = MEMBER_ROLE_LABEL[role] || role;
  const editable = !!onChangeRole && !NON_EDITABLE_ROLES.has(role);

  function openPopper(event) {
    event.stopPropagation();
    const options = MEMBER_ROLES.map((option) => ({
      id: option.id,
      label: option.label,
      checked: option.id === role,
      onClick: () => onChangeRole(member, option.id),
    }));
    popperRef.current?.open(options, "bottom-end", event.currentTarget);
  }

  if (!editable) {
    return (
      <span className={`members-list-role members-list-role--${tone}`}>
        <Text.span contrast={8}>{label}</Text.span>
        <LockRounded className="members-list-role__lock" />
      </span>
    );
  }

  return (
    <>
      <button
        type="button"
        className={`members-list-role members-list-role--${tone} members-list-role--editable`}
        onClick={openPopper}
      >
        <Text.span contrast={8}>{label}</Text.span>
        <KeyboardArrowDownRounded className="members-list-role__caret" />
      </button>
      <Popper controlRef={popperRef} />
    </>
  );
}
